import { HttpInsuranceBenefitApprovalPaymentService } from './../../../service/http-insurance-benefit-payment-approval.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PolicyBenefitPaymentDto } from '../../../service/dto-insurance';
import { ResultListDto } from '../../../service/dto';
import { finalize, Subscription } from 'rxjs';
import { OnTableChange, TableColumn } from '../../../components/table/table.component';
import { Router } from '@angular/router';

@Component({
	selector: 'app-benefit-payment-approval-list',
	standalone: false,
	templateUrl: './benefit-payment-approval-list.component.html',
	styleUrl: './benefit-payment-approval-list.component.scss'
})
export class BenefitPaymentApprovalListComponent implements OnInit, OnDestroy {
	data?: ResultListDto<PolicyBenefitPaymentDto>;
	pageIndex = 1;
	pageSize = 30;
	subscription = new Subscription();

	rejectionReason: string = '';
	loading = false;
	columnRef: TableColumn[] = [
		{ "title": "ID", "property": "id" },
		{ "title": "Workflow", "property": "workflow.label" },
		{ "title": "Product", "property": "product.name" },
		{ "title": "Policy", "property": "policy.policyNumber" },
		{ "title": "From bank account", "property": "fromBankAccount.accountNumber" },
		{ "title": "Recipient: Bank Account", "property": "toBankAccount.accountNumber" },
		{ "title": "Recipient: Name", "cellRef": "beneficiaryRef"},
		{ "title": "Payment Date", "property": "scheduledPaymentDate" },
		{ "title": "Payment Amount", "cellRef": "benefitPaymentAmountRef" },
		{ "title": "Action", "cellRef": "actionRef" }
	];


	constructor(private httpService: HttpInsuranceBenefitApprovalPaymentService, private router: Router) {
	}
	ngOnInit(): void {
		this.doFetchUploads({ pageIndex: this.pageIndex, pageSize: this.pageSize, filters: [] });
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	doFetchUploads(input: OnTableChange) {
		this.pageIndex = input.pageIndex;
		this.pageSize = input.pageSize;
		this.loading = true;

		this.httpService.getPendingBenefitPayments(this.pageIndex, this.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.data = result;
			});
	}
	approve(input: PolicyBenefitPaymentDto) {
		input.statusApproval = 'Approved';
	}
	reject(input: PolicyBenefitPaymentDto) {
		input.statusApproval = 'Rejected';
	}
	onSubmit() {
		const list = this.data!.list.filter(item => item.statusApproval === 'Rejected' || item.statusApproval === 'Approved');
		this.httpService.doApproval(list, this.rejectionReason).subscribe(item => this.doFetchUploads({ pageIndex: 1, pageSize: this.pageSize, filters: [] }));
	}

	get hasRejections(): boolean {
		return this.data!.list.some(item => item.statusApproval === 'Rejected') ?? false;
	}

	get approvedCount(): number {
		return this.data!.list.filter(item => item.statusApproval === 'Approved').length ?? 0;
	}

	get rejectedCount(): number {
		return this.data!.list.filter(item => item.statusApproval === 'Rejected').length ?? 0;
	}

	get pendingCount(): number {
		return this.data!.list.filter(item => item.statusApproval === 'Pending').length ?? 0;
	}

	get canSubmit(): boolean {
		const anyActioned = this.rejectedCount > 0 || this.approvedCount > 0;
		// const allActioned = this.pendingCount === 0;
		const reasonProvided = !this.hasRejections || this.rejectionReason?.trim().length > 0;
		return anyActioned && reasonProvided;
	}
}
